module.exports = __webpack_public_path__ + "static/media/camera_default.2b2c9832.svg";